import { Unlimited } from '../models/skyclub.interfaces';

export const NonUnlimitedMocks: Unlimited = {
  unlocked: false,
  membership: false,
  image: {
    src: '',
    alt: ''
  },
  title: '',
  subtitle: ''
};

export const UnlimitedCardMocks: Unlimited = {
  unlocked: true,
  membership: false,
  image: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/skyclub/skyclub-unlimited-fireworks.png',
    alt: 'Unlimited Skyclub Image image'
  },
  title: "You've unlocked unlimited Delta Sky Club® access.",
  subtitle: 'Valid through Jan 31, 2026'
};

export const UnlimitedMembershipMocks: Unlimited = {
  unlocked: true,
  membership: true,
  image: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/skyclub/skyclub-unlimited-fireworks.png',
    alt: 'Unlimited Skyclub Image image'
  },
  title: 'Enjoy your unlimited Delta Sky Club® access.',
  subtitle: 'Valid through Feb 31, 2026'
};
